export interface SignInTransaction {
  readonly state: string
  readonly verifier: string
  /** Where the user was going before they were interrupted. */
  readonly returnTo: string
}

const KEY = 'taler.sign-in'

export interface TransactionStore {
  put(transaction: SignInTransaction): void
  /** Reads and clears: a transaction is single use, like the code it will be traded for. */
  take(): SignInTransaction | null
}

/**
 * `sessionStorage`, because the flow survives a full-page redirect to Google and back, and
 * because it is per-tab: a transaction started in one tab must not be completable in another.
 * The verifier is not a credential on its own - it is worthless without the matching code.
 */
export function createTransactionStore(storage: Storage): TransactionStore {
  return {
    put(transaction) {
      storage.setItem(KEY, JSON.stringify(transaction))
    },
    take() {
      const raw = storage.getItem(KEY)
      storage.removeItem(KEY)
      if (raw === null) return null
      try {
        const parsed = JSON.parse(raw) as Partial<SignInTransaction>
        if (typeof parsed.state !== 'string' || typeof parsed.verifier !== 'string') return null
        return { state: parsed.state, verifier: parsed.verifier, returnTo: parsed.returnTo ?? '/' }
      } catch {
        return null
      }
    },
  }
}
